import Navbar from './components/Navbar';
import HeroSection from './components/Hero';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <HeroSection />
    </div>
  );
}

export default App;
